// 反差吃瓜 —— 站点数据（虚构内容，仅用于演示吃瓜资讯排版）
export const site = {
  name: '反差吃瓜',
  slogan: '今天值得吃的瓜，都在这里',
  desc: '反差吃瓜事件合集持续更新，热门反差名场面、爆点热闻一网打尽。',
};

export const hotList = [
  { rank: 1, tag: '爆', heat: 98.6, title: '恋综顶流男嘉宾被扒出素人期黑历史，人设当场翻车', hot: true },
  { rank: 2, tag: '热', heat: 96.3, title: '千万粉美妆博主线下直播怼脸翻车，滤镜前后判若两人', hot: true },
  { rank: 3, tag: '新', heat: 93.1, title: '某综艺导师被曝私下言行与台前判若两人', hot: true },
  { rank: 4, tag: '热', heat: 90.4, title: '富婆人设主播被拍到住出租屋，豪宅全是租的', hot: false },
  { rank: 5, tag: '热', heat: 88.7, title: '电竞冠军带货现场口误，高冷人设一秒崩成喜剧人', hot: false },
  { rank: 6, tag: '新', heat: 85.9, title: '清纯小花深夜被拍到抽烟泡吧，网友直呼不认识', hot: false },
  { rank: 7, tag: '热', heat: 82.2, title: '健身网红被爆用假腹肌特效，直播却全程穿长袖', hot: false },
  { rank: 8, tag: '新', heat: 79.5, title: '「佛系」养生主播被扒熬夜打游戏到凌晨四点', hot: false },
  { rank: 9, tag: '热', heat: 76.8, title: '一线女星机场「素颜」被偶遇，与精修图对比太真实', hot: false },
  { rank: 10, tag: '新', heat: 74.1, title: '学霸人设网红被粉丝指出连初中文凭都没有', hot: false },
];

export const categories = [
  { key: '综艺', icon: 'ri-tv-2-line', desc: '综艺对线、导师翻车、选手反差' },
  { key: '直播', icon: 'ri-live-line', desc: '直播翻车、滤镜事故、带货名场面' },
  { key: '人设', icon: 'ri-ghost-line', desc: '人设崩塌、前后对比、塌房预警' },
  { key: '网红', icon: 'ri-user-heart-line', desc: '网红日常、炫富打假、翻车实录' },
  { key: '翻车', icon: 'ri-alarm-warning-line', desc: '口误社死、现场打脸、紧急公关' },
  { key: '名场面', icon: 'ri-flashlight-line', desc: '出圈瞬间、神级对比、经典回放' },
];

export const moments = [
  {
    cate: '综艺',
    views: '86.4万',
    time: '08-28',
    title: '导师台上狂吹「敬业」，转头被曝提前离席去应酬',
    brief: '本季最猛反差：一位综艺导师在台上大谈对舞台的敬畏，结果被现场工作人员曝出彩排还没结束就已提前离场赴约，前后反差拉满，网友纷纷开始考古他的「敬业」发言。',
    img: '综艺',
  },
  {
    cate: '直播',
    views: '72.1万',
    time: '08-27',
    title: '美颜滤镜卡顿的十秒钟，主播真实颜值全网围观',
    brief: '一场本不起眼的直播因为滤镜突然卡顿，主播「精修脸」当场回归现实，画面定格十秒，弹幕直接爆炸。事后主播连夜关闭回放，但录屏早已全网疯传。',
    img: '直播',
  },
  {
    cate: '人设',
    views: '68.9万',
    time: '08-26',
    title: '「宠粉狂魔」被曝私下拉黑骂过的粉丝，还嘲讽回踩',
    brief: '某流量男星一边在镜头前营造宠粉人设，一边被爆出私下用小号与粉丝对骂、一言不合就拉黑。前粉丝放出多年聊天记录，人设与私下的落差让人直呼心寒。',
    img: '人设',
  },
  {
    cate: '网红',
    views: '61.3万',
    time: '08-25',
    title: '坐拥千万粉丝的「富豪」网红，被扒全家住出租屋',
    brief: '长期以富二代身份示人的美食网红，被粉丝顺藤摸瓜发现豪宅与豪车皆为租赁，连日常晒的「私人飞机」也是航空公司的体验套餐，反差之大瞬间登顶热榜。',
    img: '网红',
  },
  {
    cate: '翻车',
    views: '57.8万',
    time: '08-24',
    title: '学霸导师直播连线答不出题，现场沉默三分钟',
    brief: '一位以「学霸」人设出圈的考研导师在直播答疑时被弹幕提问难住，当场语塞长达三分钟，最后无奈转移话题。曾经引以为傲的知识储备惨遭全网质疑。',
    img: '翻车',
  },
  {
    cate: '名场面',
    views: '49.2万',
    time: '08-23',
    title: '选秀选手台前谦逊后辈，台下却对工作人员颐指气使',
    brief: '节目里温顺有礼的「礼貌担当」，被多位工作人员联合爆料私下态度恶劣、对助理呼来喝去。台前台后的鲜明反差，成了今年选秀最出圈的瓜之一。',
    img: '名场面',
  },
];

export const feeds = [
  {
    id: 'f1', cate: '综艺', hot: '爆',
    title: '恋综男嘉宾素人期被扒，节目组紧急删镜头',
    intro: '人气恋综男嘉宾台前深情专一，素人时期与前任的聊天记录被曝光后形象彻底反转，节目组连夜删除相关镜头，吃瓜群众感慨「剧本都不敢这么写」。',
    time: '2小时前', comments: '1.2万', img: 'a',
  },
  {
    id: 'f2', cate: '直播', hot: '热',
    title: '带货一姐被质疑卖假货，当场情绪失控下播',
    intro: '头部主播在直播间被粉丝刷屏质疑产品质量，情绪失控当场怒摔样品下播。事后公司紧急发声明致歉，但这波「甩脸」名场面已被逐帧解读。',
    time: '5小时前', comments: '8934', img: 'b',
  },
  {
    id: 'f3', cate: '人设', hot: '新',
    title: '「社恐」明星被拍到酒吧热舞，反差有点大',
    intro: '对外一直自称社恐、不喜社交的年轻偶像，被路人拍到深夜在酒吧玩得忘我。经纪人回应称「只是朋友聚会」，但网友显然并不买账。',
    time: '8小时前', comments: '5602', img: 'c',
  },
  {
    id: 'f4', cate: '网红', hot: '热',
    title: '炫富网红晒「限量车」，被网友扒出是贴膜高仿',
    intro: '某汽车博主刚晒出「限量超跑」炫耀，就被眼尖网友发现细节与真车完全对不上，疑似高仿贴膜。随后该博主默默删除动态，连车标都不敢再入镜。',
    time: '11小时前', comments: '4120', img: 'd',
  },
  {
    id: 'f5', cate: '翻车', hot: '新',
    title: '大师在线批命翻车，被观众当场对台词',
    intro: '一位「玄学大师」直播连麦批命，却被观众发现其套路话术来自早年被扒的模板。当场对上台词后弹幕彻底沸腾，「大师」秒变「剧本演员」。',
    time: '14小时前', comments: '3088', img: 'e',
  },
];

export const faqs = [
  {
    q: '什么是「反差吃瓜」？',
    a: '反差吃瓜指的是把公众人物、网红在镜头前展示的形象，与其私下被扒出的真实言行进行对比，当两者的落差足够大、足够有戏剧性时，就会成为一个「反差瓜」。我们把这些名场面与热闻系统整理、持续更新，方便你快速追瓜。',
  },
  {
    q: '吃瓜内容多久更新一次？',
    a: '我们的反差吃瓜事件合集基本做到每日更新。遇到突发的爆点热闻会在第一时间抢鲜同步，同时每周还会额外整理一期「本周名场面」盘点，保证不错过任何一个值得吃的瓜。',
  },
  {
    q: '网站里的瓜保真吗？信源来自哪里？',
    a: '我们坚持「不站队、不抢跑」的原则，尽量以可查证的一手截图、视频和多方信源交叉核实后再整理发布。为避免误伤，涉及真实个人的爆料会保留事实核对环节，模棱两可的内容会明确标注「存疑」。',
  },
  {
    q: '能不能投稿自己看到的反差瓜？',
    a: '当然可以。如果你在网络上发现了反差明显的名场面或热闻，欢迎通过站内留言或邮箱把素材发给我们，经核实后我们会整理进事件合集，并尽量标注来源。',
  },
  {
    q: '收藏本站入口有什么好处？',
    a: '把本站收藏进浏览器书签，你就能随时通过反差吃瓜事件合集入口，在几分钟内看完当天值得吃的瓜，配合「名场面」和「热闻盘点」栏目，不会再错过任何爆点。',
  },
  {
    q: '网站会一直免费吗？',
    a: '反差吃瓜目前完全免费开放，不设付费墙。我们靠内容吸引同好、通过正当的广告与合作为生，未来即便增加会员栏目，基础的每日吃瓜速览也会保持免费。',
  },
];